<div class="promotion-container" *ngIf="details">
    <a class="promotion-link" [href]="'#/details/' + details.id">
        <div class="details-poster">
            <div class="details-shadow2 details-shadow-2"></div>
            <div class="details-shadow-3"></div>
            <img class="w-100 lazyload" appLazyload="{{details.images | getImage:'wallpapers':'original'}}" appLazyPlaceholder="h" (error)="'assets/images/placeholders/placeholder_h.png'" />
        </div>

        <!-- Details -->
        <div class="details-info">
            <div class="container-fluid">
                <!-- Info -->
                <div class="row">
                    <div class="col-md-12">
                        <img class="on-demand-logo" [src]="details.type == 0 ? 'assets/images/ondemand.png' : 'assets/images/series_white.png'" />
                        <h1 class="details-title display-4 ui-overflow text-style">{{details.title}}</h1>
                        <!-- Line -->
                        <div class="sep-line pb-2"></div>
                        <div [innerHTML]="details | setupSubInfo:lang"></div>
                    </div>

                    <div class="col-md-6 pr-5 d-big">
                        <p>{{details.description}}</p>
                    </div>
                </div>
            </div>
        </div>
    </a>
</div>